import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { getTenantCode } from 'utils/misc';
import { Container, Header } from 'components/HeroSemantic';
import { Table } from 'components';

const HEADERS = [
  { id: 'roomCategory', content: <FormattedMessage id="page.occupancy.label.roomCategory" /> },
  { id: 'avgOwnerNights', content: <FormattedMessage id="page.occupancy.label.avgOwnerNights" /> },
  { id: 'avgSoldNights', content: <FormattedMessage id="page.occupancy.label.avgSoldNights" /> },
];

export default class FutureBookings extends Component {
  static propTypes = {
    statistics: PropTypes.object.isRequired,
  };

  get title() {
    const { id, futureStatsStartDate } = this.props.statistics;
    return (
      <Header as="h2">
        <FormattedMessage id={`tenant.${getTenantCode(id)}.name`} />
        &nbsp;
        <FormattedMessage id="page.occupancy.label.futureBookings.title" />
        <Header.Subheader>
          <FormattedMessage
            id="page.occupancy.label.futureBookings.subtitle"
            values={{ date: moment(futureStatsStartDate).format('l') }}
          />
        </Header.Subheader>
      </Header>
    );
  }

  get body() {
    const { roomCategories } = this.props.statistics;

    return Array.isArray(roomCategories) ? roomCategories.map(cat => ({
      id: cat.name,
      content: [
        cat.name,
        cat.avgOwnerNights,
        cat.avgSoldNights,
      ],
    })) : [];
  }

  render() {
    return (
      <Container style={{ padding: '20px' }}>
        { this.title }
        <Table headers={HEADERS} body={this.body} />
      </Container>
    );
  }
}
